import { User } from 'model';
import { FixedField } from '../../components/Forms/FixedField.js';
import { UserItem } from '../../components/admin/UserItem.js';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../../styles/Shared.module.css';
export const ActivateModal: React.FC<{
	user: User | undefined;
}> = ({ user }) => {
	return (
		<div>
			<div className={sharedStyles.userContainer}>{user && <UserItem user={user} modal={true} />}</div>
			{user && <FixedField label="Email" field={user.email} />}
			<div className="space20" />
			<h4 style={{ marginBottom: '40px' }}>
				<>
					{`Are you sure you want to ${user?.active ? 'Deactivate ' : 'Activate '}`}
					<span className={sharedStyles.highlight}>{user?.username}</span>?
				</>
			</h4>
		</div>
	);
};
